<script setup lang="ts">
  defineProps({
    homepage: Object,
  });
</script>
<template>
  <AppWrapper>
    <AccessDisclaimerModal />
    <HeaderContainer />
    <slot />
    <SiteFooter />
  </AppWrapper>
</template>
